import { t } from "i18next";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useLocation } from "react-router-dom";
import WorkerEvents from "./WorkerEvents";

const localizer = momentLocalizer(moment);

const WorkerCalendar = ({ handleSelectEvent, allAppointments }) => {
  const state = useLocation();

  const eventStyleGetter = (event) => {
    let style = {
      borderRadius: "5px",
      color: "#000",
      display: "block",
    };

    if (event.status === "completed" && event.workerStatus === "accepted") {
      style.backgroundColor = "#D3FFE2";
      style.border = "2px solid #9ef9bd";
    } else if (
      event.status === "accepted" &&
      event.workerStatus === "accepted"
    ) {
      style.backgroundColor = "#FDEEE6";
      style.border = "2px solid #EA580C";
    } else if (
      event.status === "pending" &&
      event.workerStatus === "rejected"
    ) {
      style.backgroundColor = "rgb(250, 181, 160)";
      style.border = "2px solid rgb(255, 75, 20)";
    } else {
      style.backgroundColor = "#fcad389e";
      style.border = "2px solid #FCAD38";
    }

    return {
      className: "custom-event",
      style: style,
      title: "",
    };
  };

  const formats = {
    timeGutterFormat: (date, culture, localizer) =>
      localizer.format(date, "h:mm a", culture).replace(" ", "\n"),
    dayHeaderFormat: (date, culture, localizer) =>
      localizer.format(date, "dddd, MMMM DD, YYYY", culture),
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={allAppointments}
        startAccessor="start"
        endAccessor="end"
        selectable
        onSelectEvent={handleSelectEvent}
        defaultView="day"
        views={["day", "week"]}
        formats={formats}
        tooltipAccessor={() => null}
        step={15}
        timeslots={2}
        components={{
          event: WorkerEvents,
        }}
        eventPropGetter={eventStyleGetter}
        style={{ height: "100vh" }}
        messages={{
          next: t("nexts"),
          previous: t("previous"),
          today: t("today"),
          month: t("month"),
          week: t("week"),
          day: t("day"),
        }}
      />
    </div>
  );
};

export default WorkerCalendar;
